module.exports = __webpack_public_path__ + "img/安全培训-bg.5e205d9c.jpg";